// extracted by mini-css-extract-plugin
module.exports = {"text":"text--E0rng","tissInfo":"tissInfo--1JGN5"};